import React from "react"
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'


interface OwnProps {
  imageData: IGatsbyImageData;
  onButtonClick?: (platform: string) => void
  storeLink?: string;
}

type GooglePlayButtonProps = OwnProps

export const GooglePlayButton: React.FC<GooglePlayButtonProps> = ({
  imageData,
  onButtonClick,
  storeLink
}) => {
  const AppImage = () => {
    return (
      <GatsbyImage
        alt="Google Play Store"
        image={imageData}
      />
    )
  };
  return (
    <>
      {storeLink && onButtonClick
        ? <a className="inline-block align-middle" href={storeLink} onClick={() => onButtonClick("Android")}>
            <AppImage />
          </a>
        : <div className="inline-block align-middle">
            <AppImage />
          </div>
      }
    </>
  )
}
